import { Button, Card, Col, Drawer, Row, Space, Tag } from 'antd';
import type { CompareState } from '../types.js';

type CompareCardProps = {
  compare: CompareState | null;
  compareLoading: boolean;
  onRefresh: () => void;
  diffOpen: boolean;
  onDiffOpenChange: (open: boolean) => void;
};

export function CompareCard({
  compare,
  compareLoading,
  onRefresh,
  diffOpen,
  onDiffOpenChange,
}: CompareCardProps) {
  const showDiff = compare?.off && compare?.on;

  return (
    <>
      <Card
        title="Compare (GPC Off vs On)"
        extra={
          <Button size="small" onClick={() => void onRefresh()} loading={compareLoading}>
            Refresh
          </Button>
        }
      >
        {compare ? (
          <Row gutter={12}>
            <Col xs={24} md={12}>
              <Card size="small" title="GPC Off">
                {compare.off ? (
                  <Space wrap>
                    <span>new 3P:</span>
                    <Tag color="volcano">{compare.off.new3p}</Tag>
                    <span>cookie issues:</span>
                    <Tag color="geekblue">{compare.off.cookieIssues}</Tag>
                    <span>header issues:</span>
                    <Tag color="gold">{compare.off.headerIssues}</Tag>
                    {compare.off.headerTitles && compare.off.headerTitles.length > 0 && (
                      <div style={{ width: '100%', fontSize: 12, color: '#666' }}>
                        Top headers: {compare.off.headerTitles.join('; ')}
                      </div>
                    )}
                  </Space>
                ) : (
                  <span style={{ color: '#888' }}>No recent run</span>
                )}
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card size="small" title="GPC On">
                {compare.on ? (
                  <Space wrap>
                    <span>new 3P:</span>
                    <Tag color="volcano">{compare.on.new3p}</Tag>
                    <span>cookie issues:</span>
                    <Tag color="geekblue">{compare.on.cookieIssues}</Tag>
                    <span>header issues:</span>
                    <Tag color="gold">{compare.on.headerIssues}</Tag>
                    {compare.on.headerTitles && compare.on.headerTitles.length > 0 && (
                      <div style={{ width: '100%', fontSize: 12, color: '#666' }}>
                        Top headers: {compare.on.headerTitles.join('; ')}
                      </div>
                    )}
                  </Space>
                ) : (
                  <span style={{ color: '#888' }}>No recent run</span>
                )}
              </Card>
            </Col>
            {showDiff && (
              <Col xs={24}>
                <div
                  style={{
                    marginTop: 8,
                    color: '#666',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    flexWrap: 'wrap',
                  }}
                >
                  Δ new 3P (off-on):{' '}
                  <Tag color="purple">{compare.off.new3p - compare.on.new3p}</Tag> Δ cookie issues
                  (off-on):{' '}
                  <Tag color="purple">{compare.off.cookieIssues - compare.on.cookieIssues}</Tag> Δ
                  header issues (off-on):{' '}
                  <Tag color="purple">{compare.off.headerIssues - compare.on.headerIssues}</Tag>
                  <Button size="small" onClick={() => onDiffOpenChange(true)}>
                    View diff
                  </Button>
                </div>
              </Col>
            )}
          </Row>
        ) : (
          <span style={{ color: '#888' }}>No data</span>
        )}
      </Card>

      <Drawer
        title="Header issues diff (GPC Off vs On)"
        placement="right"
        width={Math.min(560, typeof window !== 'undefined' ? window.innerWidth - 40 : 560)}
        onClose={() => onDiffOpenChange(false)}
        open={diffOpen}
      >
        {showDiff ? (
          <Row gutter={[12, 12]}>
            <Col xs={24} md={12}>
              <Card size="small" title="Off-only">
                <Space wrap>
                  {(() => {
                    const offOnly = (compare.off?.headerAll || []).filter(
                      (tag) => !(compare.on?.headerAll || []).includes(tag),
                    );
                    return offOnly.length > 0
                      ? offOnly.map((tag, index) => (
                          <Tag key={tag + index} color="red">
                            {tag}
                          </Tag>
                        ))
                      : '—';
                  })()}
                </Space>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card size="small" title="On-only">
                <Space wrap>
                  {(() => {
                    const onOnly = (compare.on?.headerAll || []).filter(
                      (tag) => !(compare.off?.headerAll || []).includes(tag),
                    );
                    return onOnly.length > 0
                      ? onOnly.map((tag, index) => (
                          <Tag key={tag + index} color="green">
                            {tag}
                          </Tag>
                        ))
                      : '—';
                  })()}
                </Space>
              </Card>
            </Col>
          </Row>
        ) : (
          <span style={{ color: '#888' }}>No data</span>
        )}
      </Drawer>
    </>
  );
}
